// extracted by mini-css-extract-plugin
module.exports = {"my-account":"myaccount-button_my-account__KbWPV","text":"myaccount-button_text__puDiu"};